import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/views/frame/mainpage'
import Home from '@/views/home/index'
import NOPermission from '@/views/home/nopermission'

//订单管理
import Order from '@/views/order/order'
import NewOrder from '@/views/order/neworder'
import CheckOrder from '@/views/order/checkorder'
import EditOrder from '@/views/order/editorder'

//商品管理
import Goods from '@/views/goods/goods'
import GoodsList from '@/views/goods/goodslist'
import NewGoods from '@/views/goods/newgoods'

//结算中心
import AccountingCenter from '@/views/accountingcenter/accountingcenter'
import Invoice from '@/views/accountingcenter/invoice'
import Bill from '@/views/accountingcenter/bill'
import Recharge from '@/views/accountingcenter/recharge'
import Watercourse from '@/views/accountingcenter/watercourse'

//个人中心
import UserCenter from '@/views/usercenter/usercenter'
import UserInfo from '@/views/usercenter/userinfo'
import CommonProduct from '@/views/usercenter/commonproduct'
import UserAddress from '@/views/usercenter/useraddress'
import Customsclearance from '@/views/usercenter/customsclearance'

//订单费用
import OrderCharge from '@/views/charge/ordercharge'


//用户管理
import User from '@/views/user/user'
import Staff from '@/views/user/staff'
import Jurisdiction from '@/views/user/jurisdiction'

//错误页面
import Forbidden from '@/error/403'

// 系统公告
import Bulletin from '@/views/usercenter/bulletin'

// 最新消息
import Message from '@/views/usercenter/message'


//系统信息
import Systeminfo from '@/views/usercenter/systeminfo'

// 更新报价
import Quotation from '@/views/usercenter/quotation'
import RemoteZipcode from '@/views/op/remote_zipcode'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [{
    path: '/',
    component: MainPage,
    children: [{
        path: '/',
        name: '首页',
        component: Home
      },{
        path: '/login',
        component: () => import('@/views/login/index'),
        hidden: true
      },
      {
        path: '/nopermission',
        name: '无权限页面',
        component: NOPermission
      },
      {
        path: '/order',
        name: '订单管理',
        component: Order
      },
      {
        path: '/neworder',
        name: '新建订单',
        component: NewOrder
      },
      {
        path: '/checkorder',
        name: '查看订单',
        component: CheckOrder
      },
      {
        path: '/editorder',
        name: '编辑订单',
        component: EditOrder
      },
      {
        path: '/goods',
        name: '商品管理',
        component: Goods,
        children: [{
            path: 'goodslist',
            name: '商品列表',
            component: GoodsList
          },
          {
            path: 'newgoods',
            name: '新建商品',
            component: NewGoods
          }
        ]
      },
      {
        path: '/accountingcenter',
        name: '结算中心',
        component: AccountingCenter,
        children: [{
            path: 'invoice',
            name: '发票',
            component: Invoice
          },
          {
            path: 'bill',
            name: '账单',
            component: Bill
          },
          {
            path: 'recharge',
            name: '充值',
            component: Recharge
          },
          {
            path: 'watercourse',
            name: '交易流水',
            component: Watercourse
          }
        ]
      },
      {
        path: '/usercenter',
        name: '个人中心',
        component: UserCenter,
        children: [{
            path: 'userinfo',
            name: '账户信息',
            component: UserInfo
          },
          // { path: 'commonproduct', name: '常用产品', component: CommonProduct},
          {
            path: 'useraddress',
            name: '地址管理',
            component: UserAddress
          }
          // ,
          // {
          //   path: 'customsclearance',
          //   name: '报关行&清关行',
          //   component: Customsclearance
          // }
        ]
      },
      {
        path: '/user',
        name: '用户管理',
        component: User,
        children: [{
            path: 'staff',
            name: '内部员工',
            component: Staff
          },
          {
            path: 'jurisdiction',
            name: '权限分配',
            component: Jurisdiction
          },
        ]
      },
      {
        path: '403',
        name: '403',
        component: Forbidden
      },
      {
        path: 'bulletin',
        name: 'bulletin',
        component: Bulletin
      },
      {
        path: 'message',
        name: 'message',
        component: Message
      }, {
        path: 'quotation',
        name: 'quotation',
        component: Quotation
      },
      {
        path: 'systeminfo',
        name: 'systeminfo',
        component: Systeminfo
      },
      {
        path: '/ordercharge',
        name: '订单费用',
        component: OrderCharge
      },
      {
        path: '/remote-zipcode',
        name: '偏远邮编',
        component: RemoteZipcode
      }
    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js